/**
 * @desc 审批
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(body: defs.tms.PayRequestResultDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/paymentMaster/approval`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
